var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"time"},[_vm._v("健康证后台管理系统")])])])
}]

export { render, staticRenderFns }